import amazon from '../assets/images/logos/amazon.png';
import ekomi from '../assets/images/logos/ekomi.png';
import glassdoor from '../assets/images/logos/glassdoor.png';
import golocal from '../assets/images/logos/golocal.png';
import google from '../assets/images/logos/google.png';
import indeed from '../assets/images/logos/indeed.png';
import kununu from '../assets/images/logos/kununu.png';
import trustedshops from '../assets/images/logos/trustedshops.png';
import trustpilot from '../assets/images/logos/trustpilot.svg';
import airbnb from '../assets/images/logos/airbnb.svg';
import tripadvisor from '../assets/images/logos/tripadvisor.svg';
import hotels from '../assets/images/logos/hotels.svg';
import amazonde from '../assets/images/logos/amazonde.svg';
import appstore from '../assets/images/logos/appstore.svg';
import playstore from '../assets/images/logos/playstore.svg';
import ebay from '../assets/images/logos/ebay.svg';
import idealo from '../assets/images/logos/idealo.svg';
import shopauskunft from '../assets/images/logos/shopauskunft.png';
import jameda from '../assets/images/logos/jameda.png';
import sanego from '../assets/images/logos/sanego.png';
import booking from '../assets/images/logos/booking.svg';
import yelp from '../assets/images/logos/yelp.svg';
import gmbDefaultImage from '../assets/images/gmb_default_location.png';
import expedia from '../assets/images/logos/expedia.svg';
import facebook from '../assets/images/logos/facebook.svg';
import aerzte from '../assets/images/logos/aerzte.png';
import holidaycheck from '../assets/images/logos/holidaycheck.svg';
import mobile from '../assets/images/logos/mobile.png';
import autoscout24 from '../assets/images/logos/autoscout24.png';
import tellows from '../assets/images/logos/tellows.png';
import immobilienscout24 from '../assets/images/logos/immoscout24.svg.png';
import gutebanken from '../assets/images/logos/gutebanken.png';
import check24 from '../assets/images/logos/check24.png';
import fewodirekt from '../assets/images/logos/fewo.svg';
import trivago from '../assets/images/logos/trivago.png';
import jobvoting from '../assets/images/logos/jobvoting.png';
import capterra from '../assets/images/logos/capterra.svg';
import omr from '../assets/images/logos/omr.png';
import speisekarte from '../assets/images/logos/speisekarte.svg';
import lieferando from '../assets/images/logos/lieferando.svg';
import opentable from '../assets/images/logos/opentable.svg';
import klinikbewertungen from '../assets/images/logos/klinikbewertungen.png';

export const constants = {
  components: {
    SIDEBAR_EXPANDED_WIDTH: '300px',
    SIDEBAR_COLLAPSED_WIDTH: '64px',
  } as const,
  imprecise_platforms: ['lieferando'],
  platform_logos: {
    immobilienscout24: immobilienscout24,
    airbnb: airbnb,
    amazon: amazon,
    ekomi: ekomi,
    glassdoor: glassdoor,
    golocal: golocal,
    google: google,
    indeed: indeed,
    kununu: kununu,
    trustedshops: trustedshops,
    trustpilot: trustpilot,
    tripadvisor: tripadvisor,
    hotels: hotels,
    amazonde: amazonde,
    appstore: appstore,
    playstore: playstore,
    idealo: idealo,
    shopauskunft: shopauskunft,
    jameda: jameda,
    sanego: sanego,
    ebay: ebay,
    yelp: yelp,
    booking: booking,
    expedia: expedia,
    facebook: facebook,
    aerzte: aerzte,
    holidaycheck: holidaycheck,
    mobile: mobile,
    autoscout24: autoscout24,
    tellows: tellows,
    googleplace: google,
    gutebanken: gutebanken,
    check24: check24,
    eBay: ebay,
    trivago: trivago,
    fewo: fewodirekt,
    jobvoting: jobvoting,
    capterra: capterra,
    omr: omr,
    speisekarte: speisekarte,
    'speisekarte.de': speisekarte,
    lieferando: lieferando,
    opentable: opentable,
    'klinikbewertungen.de': klinikbewertungen,
    klinikbewertungen: klinikbewertungen,
  } as PlatformLogo,
  gmbDefaultImage: gmbDefaultImage,
  communityManagement: {
    tonalityOptions: [
      'tonality_personal',
      'tonality_formal',
      'tonality_motivating',
      'tonality_constructive',
      'tonality_informal',
    ],
    pronounOptions: ['pronoun_you_personal', 'pronoun_you_formal'],
  } as const,
  tonality: ['personal', 'formal', 'motivating', 'constructive', 'informal'],
};
